import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';
import { Input } from '@app/form';
import { ShortTextField } from '@app/api';

const useStyles = createUseStyles((theme: Theme) => ({
  questionLabel: {
    ...theme.fonts.label,
  },
  blankInput: {
    marginTop: theme.marginBase * 2,
  },
  required: {
    color: theme.colors.red,
  },
  containerError: {
    border: `1px solid ${theme.colors.red}`,
  },
}));

interface Props {
  isPreview?: boolean;
  field: ShortTextField;
}

export const ShortText = ({ isPreview, field }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const { t } = useTranslation();

  return (
    <>
      <label className={classes.questionLabel}>
        {field.title || t('screeningForm.noQuestion')}{' '}
        {field.validation && field.validation.required && (
          <strong className={classes.required}>*</strong>
        )}
      </label>
      <Input
        className={classes.blankInput}
        disabled={isPreview}
        name="text"
        preview
        noMargin
      />
    </>
  );
};
